import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactToPrint from 'react-to-print';
import { APIHandler, PrintComponent, StorageHandler } from 'C4';
import { name, storageKeys } from 'settings';

const params = new URLSearchParams(window.location.search);
let mobile = false;
if (params.get('mobile')) {
  mobile = true;
}

export default class Diploma extends Component {
  constructor(props) {
    super(props);

    this.state = {
      diplomaLoaded: false,
      clientName: '',
    };
  }

  setComponentRef = (ref) => {
    this.componentRef = ref;
  };

  reactToPrintContent = () => {
    return this.componentRef;
  };

  toggle(diplomaLoaded) {
    this.setState({ diplomaLoaded });
  }

  componentDidMount() {
    this.getAppInfo();
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      const { clientName } = appInfo;
      this.setState({ clientName });
    }
  }

  render() {
    const { appId, firstName, lastName, hide } = this.props;
    const { clientName } = this.state;
    const image = `https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=${appId}`;
    const subject = encodeURIComponent(`${name} diploma`);
    const body = encodeURIComponent(image);

    return (
      <div
        id="diploma"
        className="fancybox-share diploma"
        style={{ display: hide ? 'none' : 'block' }}
      >
        {mobile && (
          <img
            className="diploma__image"
            name="diploma"
            src={image}
            alt="diploma"
            loading="lazy"
          />
        )}
        {!mobile && (
          <PrintComponent
            appId={appId}
            firstName={firstName}
            lastName={lastName}
            ref={this.setComponentRef}
            style={{ display: 'none' }}
            className="diploma__image"
            name="diploma"
            alt="diploma"
          />
        )}

        <div className="buttons__diploma">
          <ReactToPrint
            content={this.reactToPrintContent}
            trigger={() => (
              <div
                disabled={!this.state.diplomaLoaded}
                className="fancybox-share__button fancybox-share__button--fb"
              >
                <FontAwesomeIcon icon={['fas', 'print']} />
                <span> {i18n.translate('reportCard.print')}</span>
              </div>
            )}
          />
          <a
            href={`mailto:?subject=${subject}&body=${body}`}
            className="fancybox-share__button fancybox-share__button--pt"
          >
            <FontAwesomeIcon icon={['fas', 'at']} />
            <span>{i18n.translate('reportCard.email')}</span>
          </a>
          <a
            href={APIHandler.getDownloadURL(
              image,
              `${name} Diploma ${firstName} ${lastName}.png`
            )}
            className="fancybox-download__button fancybox-download__button--pt"
          >
            <FontAwesomeIcon icon={['fas', 'download']} />
            <span>{i18n.translate('reportCard.download')}</span>
          </a>
        </div>
      </div>
    );
  }
}

Diploma.propTypes = {
  appId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  hide: PropTypes.bool,
};

Diploma.defaultProps = {
  appId: -1,
  firstName: '',
  lastName: '',
  hide: false,
};
